import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut } from 'lucide-react';
import DashboardTab from './tabs/DashboardTab';
import LandTab from './tabs/LandTab';
import CropsTab from './tabs/CropsTab';
import InventoryTab from './tabs/InventoryTab';
import FinanceTab from './tabs/FinanceTab';
import LaborTab from './tabs/LaborTab';
import HarvestSalesTab from './tabs/HarvestSalesTab';
import ReportsTab from './tabs/ReportsTab';
import BuyersTab from './tabs/BuyersTab';
import ProfitabilityTab from './tabs/ProfitabilityTab';
import SettingsTab from './tabs/SettingsTab';

const TABS = [
  { id: 'dashboard',     label: '📊 Dashboard' },
  { id: 'land',          label: '🌍 Land' },
  { id: 'crops',         label: '🌾 Crops' },
  { id: 'inventory',     label: '🏪 Inventory' },
  { id: 'finance',       label: '💰 Finance' },
  { id: 'labor',         label: '👷 Labor' },
  { id: 'harvest-sales', label: '🛒 Harvest Sales' },
  { id: 'buyers',        label: '🧑‍💼 Buyers' },
  { id: 'profitability', label: '📈 Profitability' },
  { id: 'reports',       label: '📋 Reports' },
  { id: 'settings',      label: '⚙️ Settings' },
];

const AgricultureDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  const isBusinessman = user?.role === 'businessman';
const renderTab = () => {
    switch (activeTab) {
      case 'dashboard':     return <DashboardTab />;
      case 'land':          return <LandTab />;
      case 'crops':         return <CropsTab />;
      case 'inventory':     return <InventoryTab />;
      case 'finance':       return <FinanceTab />;
      case 'labor':         return <LaborTab />;
      case 'harvest-sales': return <HarvestSalesTab />;
      case 'buyers':        return <BuyersTab />;
      case 'profitability': return <ProfitabilityTab />;
      case 'reports':       return <ReportsTab />;
      case 'settings':      return <SettingsTab />;
      default:              return <DashboardTab />;
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', fontFamily: "'Inter', sans-serif" }}>

      {/* ── Header ── */}
      <div style={{
        background: 'linear-gradient(135deg, #27ae60 0%, #1e8449 100%)',
        color: 'white',
        padding: '24px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
          {isBusinessman && (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: '10px 20px',
                background: 'rgba(255,255,255,0.2)',
                border: '1px solid rgba(255,255,255,0.3)',
                borderRadius: '8px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600'
              }}
              onMouseEnter={e => e.target.style.background = 'rgba(255,255,255,0.3)'}
              onMouseLeave={e => e.target.style.background = 'rgba(255,255,255,0.2)'}
            >
              ← Back
            </button>
          )}
          <h1 style={{ fontSize: '28px', margin: 0, fontWeight: '700', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '32px' }}>🌾</span>
            Agriculture Business
          </h1>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            padding: '10px 16px',
            background: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            👤 {user?.full_name || user?.username || 'User'}
          </div>
          <button
            onClick={logout}
            style={{
              padding: '12px 24px',
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '10px',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '600'
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>

      {/* ── Tabs ── */}
      <div style={{
        background: 'white',
        borderBottom: '2px solid #e8f5e9',
        padding: '0 40px',
        display: 'flex',
        gap: '4px',
        overflowX: 'auto'
      }}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '16px 24px',
              background: 'none',
              border: 'none',
              borderBottom: activeTab === tab.id ? '3px solid #27ae60' : '3px solid transparent',
              color: activeTab === tab.id ? '#27ae60' : '#7f8c8d',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab.id ? '700' : '500',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ── Tab Content ── */}
      <div style={{ padding: '32px 40px' }}>
        {renderTab()}
      </div>
    </div>
  );
};

export default AgricultureDashboard;